import {
  IconButton,
  Text,
  Dropdown,
  DefaultButton,
  DatePicker,
  MessageBarType,
} from '@fluentui/react';
import { FC, ReactElement, useEffect, useRef, useState } from 'react';
import {
  IFilterModalWindowProps,
} from './FilterModalWindowProps';
import classNames from 'classnames';
import apiService from '../../../../../../../api';
import styles from './FilterModalWindow.module.scss';
import { emptyFilterModalWindowState, initialFilterState } from './consts';
import { IFilterModalWindowState } from './IFilterModalWindowState';
import useNotifications from '../../../../../../../hooks/useNotifications';
import { useSelector } from 'react-redux';
import { customerSelector, locationSelector } from '../../../../../../../redux/recordKeepingSlice';
import moment from 'moment';

const FilterModalWindow: FC<IFilterModalWindowProps> = ({
  isOpened,
  filtersState,
  setFiltersData,
  filtersData,
  setAdvancedFilterData,
  advancedFilterData,
  handleFilter,
  handleClear,
  setPayloadFilterData,
}): ReactElement => {
  const [currentFilters, setCurrentFilters] = useState<any>(filtersState);
  const { id: customerId } = useSelector(customerSelector);
  const { id: locationId } = useSelector(locationSelector);

  const { addNotification } = useNotifications();

  const [state, setState] = useState<IFilterModalWindowState>(emptyFilterModalWindowState);

  const DATE_FORMAT = 'MM/DD/YYYY';

  type onSelectDateType = Date | null | undefined;

  const applyFilters = async () => {
    setCurrentFilters({ ...currentFilters });
    setPayloadFilterData(advancedFilterData);
    handleFilter();
    isOpened(false);
  };

  const clearFilters = () => {
    setCurrentFilters({ ...initialFilterState });
    setAdvancedFilterData(null);
    setPayloadFilterData(null);
    handleClear();
    isOpened(false);
  };

  const containerRef = useRef(null);

  const handleClickOutside = (event: any) => {
    if (!(containerRef.current as any).contains(event.target)) {
      isOpened(false);
    }
  };

  const fetchFilterData = async () => {
    try {
      const { data }: any = await apiService.tireDispositionQueue.getFiltersData(
        customerId,
        locationId,
      );
      const dispCodes = data.data[0]?.dispCode;
      const statuses = data.data[0]?.status;
      const surveyBy = data.data[0]?.surveyBy;
      const lastModifiedBy = data.data[0]?.lastModifiedBy;
      const surveyDateFrom = data.data[0]?.surveyDateFrom;
      const surveyDateTo = data.data[0]?.surveyDateTo;
      const dateModifiedFrom = data.data[0]?.dateModifiedFrom;
      const dateModifiedTo = data.data[0]?.dateModifiedTo;
      setState(prev => ({ ...prev, dispoCodes: dispCodes, statuses: statuses, surveyByList: surveyBy, lastModifiedByList: lastModifiedBy, selectedSurveyDateFrom: surveyDateFrom, selectedSurveyDateTo: surveyDateTo, selectedDateModifiedFrom: dateModifiedFrom, selectedDateModifiedTo: dateModifiedTo }));
      setFiltersData({ dispositionCode: dispCodes, queueStatus: statuses, surveyByList: surveyBy, lastModifiedByList: lastModifiedBy, surveyDateFrom: surveyDateFrom, surveyDateTo: surveyDateTo, dateModifiedFrom: dateModifiedFrom, dateModifiedTo: dateModifiedTo });
      console.log('filtersData', filtersData);
      console.log('state', state);
    } catch (e: any) {
      const { response } = e;
      addNotification({
        text: `Disposition Codes fetching error: ${response.data.message}`,
        type: MessageBarType.error,
      });
    } finally {
      setState((prev: any) => ({ ...prev, loading: false }));
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [containerRef]);

  useEffect(() => {
    if (filtersData == null) {
      fetchFilterData();
    } else {
      setState(prev => ({ ...prev, dispoCodes: filtersData.dispositionCode, statuses: filtersData.queueStatus, surveyByList: filtersData.surveyByList, lastModifiedByList: filtersData.lastModifiedByList, selectedDispoCodes: advancedFilterData?.dispositionCode, selectedStatuses: advancedFilterData?.queueStatus, selectedSurveyByList: advancedFilterData?.surveyBy, selectedLastModifiedByList: advancedFilterData?.lastModifiedBy, selectedSurveyDateFrom: advancedFilterData?.surveyDateFrom, selectedSurveyDateTo: advancedFilterData?.surveyDateTo, selectedDateModifiedFrom: advancedFilterData?.dateModifiedFrom, selectedDateModifiedTo: advancedFilterData?.dateModifiedTo }));
      setCurrentFilters({ ...currentFilters, dispositionCode: advancedFilterData?.dispositionCode, queueStatus: advancedFilterData?.queueStatus, surveyBy: advancedFilterData?.surveyBy, lastModifiedBy: advancedFilterData?.lastModifiedBy, surveyDateFrom: advancedFilterData?.surveyDateFrom, surveyDateTo: advancedFilterData?.surveyDateTo, dateModifiedFrom: advancedFilterData?.dateModifiedFrom, dateModifiedTo: advancedFilterData?.dateModifiedTo });
    }
  },[]);

  const handleDispCodeChange = (item: any): void => {
    const selectedFilters = [...state.selectedDispoCodes];
    if (item.selected) {
      selectedFilters.push(item?.key);
      setState((prev: any) => ({ ...prev, selectedDispoCodes: selectedFilters }));
      setCurrentFilters({ ...currentFilters, dispositionCode: selectedFilters });
      setAdvancedFilterData({ ...currentFilters, dispositionCode: selectedFilters });
    } else {
      setState((prev: any) => ({ ...prev, selectedDispoCodes: selectedFilters.filter(row => row !== item?.key) }));
      setCurrentFilters({ ...currentFilters, dispositionCode: selectedFilters.filter(row => row !== item?.key) });
      setAdvancedFilterData({ ...currentFilters, dispositionCode: selectedFilters.filter(row => row !== item?.key) });
    }
  };

  const handleStatusChange = (item: any): void => {
    const selectedFilters = [...state.selectedStatuses];
    if (item.selected) {
      selectedFilters.push(item?.key);
      setState((prev: any) => ({ ...prev, selectedStatuses: selectedFilters }));
      setCurrentFilters({ ...currentFilters, queueStatus: selectedFilters });
      setAdvancedFilterData({ ...currentFilters, queueStatus: selectedFilters });
    } else {
      setState((prev: any) => ({ ...prev, selectedStatuses: selectedFilters.filter(row => row !== item?.key) }));
      setCurrentFilters({ ...currentFilters, queueStatus: selectedFilters.filter(row => row !== item) });
      setAdvancedFilterData({ ...currentFilters, queueStatus: selectedFilters.filter(row => row !== item) });
    }
  };

  const handleSurveyByChange = (item: any): void => {
    const selectedFilters = [...state.selectedSurveyByList];
    if (item.selected) {
      selectedFilters.push(item?.key);
      setState((prev: any) => ({ ...prev, selectedSurveyByList: selectedFilters }));
      setCurrentFilters({ ...currentFilters, surveyBy: selectedFilters });
      setAdvancedFilterData({ ...currentFilters, surveyBy: selectedFilters });
    } else {
      setState((prev: any) => ({ ...prev, selectedSurveyByList: selectedFilters.filter(row => row !== item?.key) }));
      setCurrentFilters({ ...currentFilters, surveyBy: selectedFilters.filter(row => row !== item?.key) });
      setAdvancedFilterData({ ...currentFilters, surveyBy: selectedFilters.filter(row => row !== item?.key) });
    }

  };

  const handleLastModifiedByChange = (item: any): void => {
    const selectedFilters = [...state.selectedLastModifiedByList];
    if (item.selected) {
      selectedFilters.push(item?.key);
      setState((prev: any) => ({ ...prev, selectedLastModifiedByList: selectedFilters }));
      setCurrentFilters({ ...currentFilters, lastModifiedBy: selectedFilters });
      setAdvancedFilterData({ ...currentFilters, lastModifiedBy: selectedFilters });
    } else {
      setState((prev: any) => ({ ...prev, selectedLastModifiedByList: selectedFilters.filter(row => row !== item?.key) }));
      setCurrentFilters({ ...currentFilters, lastModifiedBy: selectedFilters.filter(row => row !== item?.key) });
      setAdvancedFilterData({ ...currentFilters, lastModifiedBy: selectedFilters.filter(row => row !== item?.key) });
    }
  };

  return (
    <div id="filterModalWindow" className={classNames(styles.filterWrapper)}>
      <div className={classNames(styles.filterBackground)}>
        <div className={classNames(styles.filterContainer)} ref={containerRef}>
          <div className={classNames(styles.filterHeader)}>
            <Text variant="xxLarge">Filter</Text>
            <IconButton
              id="closeButton"
              iconProps={{iconName: 'Cancel'}}
              title="close"
              onClick={() => isOpened(false)}
            />
          </div>
          <div className={classNames(styles.filterBody)}>
            <div className={classNames(styles.row)}>
              <div className={classNames(styles.column)}>
                <div>
                  <label>
                    <Text variant="large">Disposition Code</Text>
                  </label>
                  <Dropdown
                    id="dispoCode"
                    selectedKeys={currentFilters.dispoCodes}
                    defaultSelectedKeys={advancedFilterData?.dispositionCode}
                    onChange={(ev: any, item: any) => handleDispCodeChange(item)}
                    multiSelect
                    options={state.dispoCodes.map(code => ({
                      key: code,
                      text: code,
                    }))}
                  />
                </div>
                <div>
                  <label>
                    <Text variant="large">Status</Text>
                  </label>
                  <Dropdown
                    id="queueStatus"
                    selectedKeys={currentFilters.statuses}
                    defaultSelectedKeys={advancedFilterData?.queueStatus}
                    onChange={(ev: any, item: any) => handleStatusChange(item)}
                    multiSelect
                    options={state.statuses.map(queueStatus => ({
                      key: queueStatus,
                      text: queueStatus,
                    }))}
                  />
                </div>
              </div>
            </div>
            <div className={classNames(styles.row)}>
              <div className={classNames(styles.column)}>
                <div>
                  <label>
                    <Text variant="large">Survey By</Text>
                  </label>
                  <Dropdown
                    id="surveyBy"
                    selectedKeys={currentFilters.surveyByList}
                    defaultSelectedKeys={advancedFilterData?.surveyBy}
                    onChange={(ev: any, item: any) => handleSurveyByChange(item)}
                    multiSelect
                    options={state.surveyByList.map(surveyBy => ({
                      key: surveyBy,
                      text: surveyBy,
                    }))}
                  />
                </div>
                <div>
                  <label>
                    <Text variant="large">Last Modified By</Text>
                  </label>
                  <Dropdown
                    id="lastModifiedBy"
                    selectedKeys={currentFilters.lastModifiedByList}
                    defaultSelectedKeys={advancedFilterData?.lastModifiedBy}
                    onChange={(ev: any, item: any) => handleLastModifiedByChange(item)}
                    multiSelect
                    options={state.lastModifiedByList.map(lastModifiedBy => ({
                      key: lastModifiedBy,
                      text: lastModifiedBy,
                    }))}
                  />
                </div>
              </div>
            </div>
            <div className={classNames(styles.row)}>
              <div className={classNames(styles.column)}>
                <div
                  className={classNames(
                    styles.column,
                    styles.calendarContainer,
                  )}
                >
                  <label>
                    <Text variant="large">Survey Date</Text>
                  </label>
                  <div>
                    <label>
                      <Text variant="medium">From</Text>
                    </label>
                    <DatePicker
                      id="surveyDateFrom"
                      showMonthPickerAsOverlay={true}
                      placeholder="Select a date..."
                      ariaLabel="Select a date"
                      value={currentFilters.surveyDateFrom ? currentFilters.surveyDateFrom : null}
                      onSelectDate={(surveyDateFrom: onSelectDateType) => { 
                        setCurrentFilters({ ...currentFilters, surveyDateFrom });
                        setAdvancedFilterData({ ...currentFilters, surveyDateFrom });
                      }}
                      formatDate={(date: any) => moment(date).format(DATE_FORMAT)}
                    />
                  </div>
                  <div>
                    <label>
                      <Text variant="medium">To</Text>
                    </label>
                    <DatePicker
                      id="surveyDateTo"
                      showMonthPickerAsOverlay={true}
                      placeholder="Select a date..."
                      ariaLabel="Select a date"
                      value={currentFilters.surveyDateTo ? currentFilters.surveyDateTo : null}
                      onSelectDate={(surveyDateTo: onSelectDateType) => { 
                        setCurrentFilters({ ...currentFilters, surveyDateTo });
                        setAdvancedFilterData({ ...currentFilters, surveyDateTo });
                      }}
                      formatDate={(date: any) => moment(date).format(DATE_FORMAT)}
                    />
                  </div>
                </div>
              </div>
              <div className={classNames(styles.column)}>
                <div
                  className={classNames(
                    styles.column,
                    styles.calendarContainer,
                  )}
                >
                  <label>
                    <Text variant="large">Date Modified</Text>
                  </label>
                  <div>
                    <label>
                      <Text variant="medium">From</Text>
                    </label>
                    <DatePicker
                      id="dateModifiedFrom"
                      showMonthPickerAsOverlay={true}
                      placeholder="Select a date..."
                      ariaLabel="Select a date"
                      value={currentFilters.dateModifiedFrom ? currentFilters.dateModifiedFrom : null}
                      onSelectDate={(dateModifiedFrom: onSelectDateType) => { 
                        setCurrentFilters({ ...currentFilters, dateModifiedFrom });
                        setAdvancedFilterData({ ...currentFilters, dateModifiedFrom });
                      }}
                      formatDate={(date: any) => moment(date).format(DATE_FORMAT)}
                    />
                  </div>
                  <div>
                    <label>
                      <Text variant="medium">To</Text>
                    </label>
                    <DatePicker
                      id="dateModifiedTo"
                      showMonthPickerAsOverlay={true}
                      placeholder="Select a date..."
                      ariaLabel="Select a date"
                      value={currentFilters.dateModifiedTo ? currentFilters.dateModifiedTo : null}
                      onSelectDate={(dateModifiedTo: onSelectDateType) => { 
                        setCurrentFilters({ ...currentFilters, dateModifiedTo });
                        setAdvancedFilterData({ ...currentFilters, dateModifiedTo });
                      }}
                      formatDate={(date: any) => moment(date).format(DATE_FORMAT)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={classNames(styles.filterFooter)}>
            <DefaultButton
              id="clearButton"
              onClick={clearFilters}
              text={'Clear Filters'}
            />
            <DefaultButton
              id="applyButton"
              onClick={applyFilters}
              text={'Apply'}
              disabled={
                ((currentFilters.surveyDateFrom > currentFilters.surveyDateTo) ||
                (currentFilters.surveyDateFrom === null && currentFilters.surveyDateTo !== null) ||
                (currentFilters.surveyDateFrom !== null && currentFilters.surveyDateTo === null)) ||
                ((currentFilters.dateModifiedFrom > currentFilters.dateModifiedTo) ||
                (currentFilters.dateModifiedFrom === null && currentFilters.dateModifiedTo !== null) ||
                (currentFilters.dateModifiedFrom !== null && currentFilters.dateModifiedTo === null))
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterModalWindow;